import api from 'src/services/api';

export function contratarAssinatura({
  number,
  verification_value,
  first_name,
  last_name,
  month,
  year,
  brand,
  identificador_iugu,
  email,
  payable_with = 'credit card',
  id_payment = null,
  cupom,
}) {
  return api.post('/criarAssinatura', {
    number,
    verification_value,
    first_name,
    last_name,
    month,
    year,
    brand,
    plan_identifier: identificador_iugu,
    email,
    payable_with,
    id_payment,
    cupom,
  });
}

export function contratarServicoComCartaoCredito({
  id,
  number,
  first_name,
  last_name,
  month,
  year,
  verification_value,
  brand,
  email,
  parcela,
  item,
  cpf_cnpj,
  address,
  username,
  servicoId,
  cupom,
  id_payment,
}) {
  return api.post('/realizarCobrancaDireta', {
    number,
    verification_value,
    first_name,
    last_name,
    month,
    year,
    brand,
    method: 'credit_card',
    email: email,
    months: parcela,
    items: [item],
    cpf_cnpj: cpf_cnpj,
    street: address ? address.logradouro : '',
    address_number: address ? address.numero : '',
    name: username,
    zip_code: address ? address.cep : '',
    complement: address ? address.complemento : '',
    id_usuario: id,
    id_servico: servicoId,
    cupom,
    id_payment,
  });
}

export function contratarServicoComPix({
  id,
  email,
  item,
  cpf_cnpj,
  username,
  servicoId,
}) {
  return api.post('/realizarCobrancaDireta', {
    method: 'pix',
    email,
    items: [item],
    cpf_cnpj,
    name: username,
    id_usuario: id,
    id_servico: servicoId,
  });
}

const PagamentoService = {
  contratarAssinatura,
  contratarServicoComCartaoCredito,
  contratarServicoComPix,
};

export default PagamentoService;
